// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__whejR","overlays":"styles_overlays__JhInw","image":"styles_image__Qjhx_","shadow":"styles_shadow__yCvsT","content":"styles_content__L3_St"};